import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  httpGetAccountLookup,
  httpSaveGmailDraft,
  httpSaveOutlookWebDraft,
  httpSavetMailchimpDraft,
  httpExportToWebhook,
  httpExportToZapeir,
  httpExportToMailJet,
  httpExportToSendGrid,
  httpExportToMake,
  httpExportToBlueShift,
  httpSavetZohoMailDraft,
  httpSavetZohoCampaignDraft,
  httpExportToKlaviyo,
  httpExportToIContact,
  httpExportToBrevo,
  httpExportToEcoMail,
  httpExportToConstantContact,
  httpExportToDotdigital,
  httpExportToSendwithus,
  httpExportToSendpulse,
  httpExportToRule,
  httpExportToMoosend,
  httpExportToPabbly,
  httpExportToSelzy,
  httpExportToCleverReach,
  httpExportToOneSignal,
  httpExportToElasticEmail,
} from 'api';
import { getErrorText, showErrorMessage } from 'helpers';

const accountLookup = createAsyncThunk(
  'exports/accountLookup',
  async ({ userId, payload }) => {
    try {
      const { data } = await httpGetAccountLookup(userId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const saveGmailDraft = createAsyncThunk(
  'exports/saveGmailDraft',
  async ({ templateId, authCode }) => {
    try {
      const { data } = await httpSaveGmailDraft(templateId, authCode);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const saveOutlookWebDraft = createAsyncThunk(
  'exports/saveOutlookWebDraft',
  async ({ templateId, authCode }) => {
    try {
      const { data } = await httpSaveOutlookWebDraft(templateId, authCode);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const saveMailchimpDraft = createAsyncThunk(
  'exports/saveMailchimpDraft',
  async ({ templateId, authCode }) => {
    try {
      const { data } = await httpSavetMailchimpDraft(templateId, authCode);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToWebhook = createAsyncThunk(
  'exports/exportToWebhook',
  async ({ templateId, webhookUrl, webhookHeaders }) => {
    try {
      const { data } = await httpExportToWebhook(
        templateId,
        webhookUrl,
        webhookHeaders,
      );

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToZapier = createAsyncThunk(
  'exports/exportToZapier',
  async ({ templateId, zapierWebhookUrl }) => {
    try {
      const { data } = await httpExportToZapeir(templateId, zapierWebhookUrl);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToMailJet = createAsyncThunk(
  'exports/exportToMailJet',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToMailJet(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToSendGrid = createAsyncThunk(
  'exports/exportToSendGrid',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToSendGrid(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToMake = createAsyncThunk(
  'exports/exportToMake',
  async ({ templateId, makeWebhookUrl }) => {
    try {
      const { data } = await httpExportToMake(templateId, makeWebhookUrl);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToBlueShift = createAsyncThunk(
  'exports/exportToBlueShift',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToBlueShift(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const saveZohoMailDraft = createAsyncThunk(
  'exports/saveZohoMailDraft',
  async ({ templateId, authCode, zohoMailRegion }) => {
    try {
      const { data } = await httpSavetZohoMailDraft(
        templateId,
        authCode,
        zohoMailRegion,
      );

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const saveZohoCampaignDraft = createAsyncThunk(
  'exports/saveZohoCampaignDraft',
  async ({ templateId, authCode, zohoCampaignRegion }) => {
    try {
      const { data } = await httpSavetZohoCampaignDraft(
        templateId,
        authCode,
        zohoCampaignRegion,
      );

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToKlaviyo = createAsyncThunk(
  'exports/exportToKlaviyo',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToKlaviyo(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToIContact = createAsyncThunk(
  'exports/exportToIContact',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToIContact(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToBrevo = createAsyncThunk(
  'exports/exportToBrevo',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToBrevo(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToEcoMail = createAsyncThunk(
  'exports/exportToEcoMail',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToEcoMail(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToConstantContact = createAsyncThunk(
  'exports/exportToConstantContact',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToConstantContact(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToDotdigital = createAsyncThunk(
  'exports/exportToDotdigital',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToDotdigital(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToSendwithus = createAsyncThunk(
  'exports/exportToSendwithus',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToSendwithus(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToSendpulse = createAsyncThunk(
  'exports/exportToSendpulse',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToSendpulse(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToRule = createAsyncThunk(
  'exports/exportToRule',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToRule(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToMoosend = createAsyncThunk(
  'exports/exportToMoosend',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToMoosend(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToPabbly = createAsyncThunk(
  'exports/exportToPabbly',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToPabbly(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToSelzy = createAsyncThunk(
  'exports/exportToSelzy',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToSelzy(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToCleverReach = createAsyncThunk(
  'exports/exportToCleverReach',
  async ({ templateId, authCode }) => {
    try {
      const { data } = await httpExportToCleverReach(templateId, authCode);
      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToOneSignal = createAsyncThunk(
  'exports/exportToOneSignal',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToOneSignal(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

const exportToElasticEmail = createAsyncThunk(
  'exports/exportToElasticEmail',
  async ({ templateId, payload }) => {
    try {
      const { data } = await httpExportToElasticEmail(templateId, payload);

      return data;
    } catch (error) {
      showErrorMessage(getErrorText());
      throw error;
    }
  },
);

export {
  accountLookup,
  saveGmailDraft,
  saveOutlookWebDraft,
  saveMailchimpDraft,
  exportToWebhook,
  exportToZapier,
  exportToMailJet,
  exportToSendGrid,
  exportToMake,
  exportToBlueShift,
  saveZohoMailDraft,
  saveZohoCampaignDraft,
  exportToKlaviyo,
  exportToIContact,
  exportToBrevo,
  exportToEcoMail,
  exportToConstantContact,
  exportToDotdigital,
  exportToSendwithus,
  exportToSendpulse,
  exportToRule,
  exportToMoosend,
  exportToPabbly,
  exportToSelzy,
  exportToCleverReach,
  exportToOneSignal,
  exportToElasticEmail,
};
